// Activated in V5.2
async function getLocalizationSuggestion() {
  try {
    const response = await fetch(
      window.Shopify.routes.root +
        "browsing_context_suggestions.json" +
        "?country[enabled]=true" +
        `&country[exclude]=${window.Shopify.country}` +
        "&language[enabled]=true" +
        `&language[exclude]=${window.Shopify.language}`
    );
    if (!response.ok) {
      throw new Error("Network request failed");
    }
    const { detected_values } = await response.json();
    return {
      detected_country: detected_values.country || { handle: "unknown" },
    };
  } catch (error) {
    console.error("Error in fetching localization suggestion:", error);
    return {
      detected_country: { handle: "unknown" },
    };
  }
}

function setCookie(name, value, daysToExpire) {
  try {
    const expirationDate = new Date();
    expirationDate.setTime(
      expirationDate.getTime() + daysToExpire * 24 * 60 * 60 * 1000
    );
    const expires = "expires=" + expirationDate.toUTCString();
    document.cookie =
      name + "=" + value + ";" + expires + ";path=/;Secure;SameSite=Strict";
  } catch (error) {
    console.error("Error in setting cookie:", error);
  }
}

function getCookie(name) {
  const cookieName = name + "=";
  const cookies = document.cookie.split(";").map((cookie) => cookie.trim());
  const foundCookie = cookies.find((cookie) => cookie.startsWith(cookieName));
  return foundCookie ? foundCookie.substring(cookieName.length) : "";
}

async function showLocalizationSuggestion() {
  const { detected_country } = await getLocalizationSuggestion();

  const isBot = /bot|googlebot|crawler|spider|bingbot|yahoo|baidu|shopifybot|lighthouse|chrome-lighthouse|google page speed/i.test(
    navigator.userAgent
  );
  const isShopifyPreview = window.location.hostname.includes("shopifypreview.com");

  if (isBot || isShopifyPreview) {
    return;
  }

  if (detected_country.handle !== "unknown" && detected_country.handle !== "CO") {
    console.log("Redirecting to INT...");
    const currentPath = window.top.location.pathname;
    const currentSearchParams = window.top.location.search;
    const urlParams = new URLSearchParams(currentSearchParams);
    urlParams.set("country", detected_country.handle);

    const newURL =
      "https://int.entreaguas.com" + currentPath + "?" + urlParams.toString();

    window.top.location.href = newURL;
  }
}

if (
  window.location.search.includes("skipredirect=true") ||
  window.location.search.includes("SkipCozyRedirect=yes")
) {
  setCookie("skipRedirection", "true", 1);
  console.log("Skip Redirect = True");
} else if (getCookie("skipRedirection") === "true") {
  console.log("Skip Redirect = True");
} else {
  showLocalizationSuggestion();
}